import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const Pagination2 = ({ filteredData, dataPerPage, handlePagination, currentPage }) => {
  const { t } = useTranslation();
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    const newTotalPages = Math.ceil(filteredData?.length / dataPerPage);
    setTotalPages(newTotalPages);

    if (currentPage > newTotalPages) {
      handlePagination(newTotalPages > 0 ? newTotalPages : 1);
    }
  }, [filteredData, currentPage, dataPerPage, handlePagination]);

  // حساب نطاق الأرقام المعروضة
  const range = 1;
  let start = currentPage - range;
  let end = currentPage + range;

  if (start < 1) {
    end += 1 - start;
    start = 1;
  }

  if (end > totalPages) {
    start -= end - totalPages;
    end = totalPages;
  }

  if (start < 1) start = 1;

  const pageNumbers = [];
  for (let i = start; i <= end; i++) {
    if (i >= 1 && i <= totalPages) {
      pageNumbers.push(i);
    }
  }

  // عدم عرض أزرار التصفح إذا كانت صفحة واحدة فقط
  if (totalPages === 1 || filteredData?.length === 0) {
    return (
      <div className='text-center text-muted mb-3'>
        {t('Showing')} {filteredData?.length} {t('Records')}
      </div>
    );
  }

  return (
    <div className='d-flex flex-column align-items-center justify-content-center gap-3 '>
      {/* <div className='text-muted small'>
        {t('EntriesVisible')}: <span className='fw-bold'>{Math.min(dataPerPage, filteredData?.length)}</span>{' '}
        {t('OfTotal')} <span className='fw-bold'>{filteredData?.length}</span>
      </div> */}

      <div className='d-flex flex-column flex-md-row align-items-center gap-3'>
        <button
          type='button'
          onClick={() => handlePagination(currentPage - 1)}
          className='btn btn-sm btn-outline-theme d-flex align-items-center gap-1'
          disabled={currentPage === 1}
        >
          <span>&#8249;</span>
          {t('Previous')}
        </button>

        <div className='d-flex gap-2'>
          {start > 1 && (
            <>
              <button type='button' className='btn btn-sm btn-outline-theme' onClick={() => handlePagination(1)}>
                1
              </button>
              {start > 2 && <span className='px-2 d-flex align-items-center text-muted'>...</span>}
            </>
          )}

          {pageNumbers.map(number => (
            <button
              key={number}
              type='button'
              className={`btn btn-sm ${number === currentPage ? 'btn-theme' : 'btn-outline-theme'}`}
              onClick={() => handlePagination(number)}
            >
              {number}
            </button>
          ))}

          {end < totalPages && (
            <>
              {end < totalPages - 1 && <span className='px-2 d-flex align-items-center text-muted'>...</span>}
              <button
                type='button'
                className='btn btn-sm btn-outline-theme'
                onClick={() => handlePagination(totalPages)}
              >
                {totalPages}
              </button>
            </>
          )}
        </div>

        <button
          type='button'
          onClick={() => handlePagination(currentPage + 1)}
          className='btn btn-sm btn-outline-theme d-flex align-items-center gap-1'
          disabled={currentPage === totalPages}
        >
          {t('Next')}
          <span>&#8250;</span>
        </button>
      </div>
    </div>
  );
};

export default Pagination2;
